import { Outlet, useSearchParams } from 'react-router-dom'
import { Header, Footer, Notification } from '@components' 
// import { InstallPWA } from '@components'
import { useCityContext } from '@contexts/LocationContext'
import { useAuth } from '@contexts/AuthContext'
import './Layout.css'

const Layout = () => {
  const { city } = useCityContext()
  const [searchParams] = useSearchParams()
  const { 
    isAuthenticated, 
    isRegistrationComplete, 
    isEmailVerified, 
    hasTemporaryPassword,
    resendVerificationEmail,
    resendCooldown,
    isResendingEmail
  } = useAuth()

  const handleResendEmail = async () => {
    if (resendCooldown > 0 || isResendingEmail) return;
    await resendVerificationEmail(city?.slug || 'uberlandia')
  }

  const formatCooldown = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }

  const renderNotification = () => {
    if (!isAuthenticated) return null;

    if (!isRegistrationComplete) {
      return (
        <Notification
          message="Complete seu cadastro para aproveitar ao máximo."
          linkTo={`/${city?.slug || ''}/completar-cadastro`}
          linkText="Completar agora"
        />
      );
    }

    // Se estiver processando um token de verificação, não mostra o banner de aviso
    const isVerifying = !!searchParams.get('verificationToken');

    if (!isEmailVerified && !isVerifying) {
      return (
        <Notification
          message={resendCooldown > 0 
            ? `E-mail enviado! Confira sua caixa de entrada e spam. Tente novamente em ${formatCooldown(resendCooldown)}, caso não receba.` 
            : "Confirme seu e-mail para poder comprar ingressos. Confira a caixa de spam. Não recebeu e-mail?"
          }
          onAction={resendCooldown > 0 || isResendingEmail ? null : handleResendEmail}
          actionText={isResendingEmail ? "Enviando..." : (resendCooldown > 0 ? "" : "Clique aqui")}
          disabled={resendCooldown > 0 || isResendingEmail}
        />
      );
    }

    if (hasTemporaryPassword) {
      return (
        <Notification
          message="Você está usando uma senha temporária. Troque-a por segurança."
          linkTo={`/${city?.slug || ''}/perfil?tab=security`}
          linkText="Trocar senha"
        />
      );
    }

    return null;
  };

  return (
    <div className="layout">
      <Header />
      {renderNotification()}
      <div className="layout__content">
        <Outlet />
      </div>
      <Footer />
      {/* <InstallPWA /> */}
    </div>
  )
}

export default Layout
